import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Control, RegisterOptions } from "react-hook-form";
import { CountryCode } from "react-native-country-picker-modal";

import { TextInputProps as CustomTextInputProps } from "../../components";
import { DEFAULT_COUNTRY_LABEL } from "../../components/AddressAutoComplete/types";

export type AccountStackParamList = {
  AccountSettings: undefined;
  AccountShow: undefined;
  JobPreferences: undefined;
  EmailChange: undefined;
  Jobs: undefined;
  AccountEdit: undefined;
  AccountEditContactInformation: undefined;
};

export type ScreenProps<name extends keyof AccountStackParamList> = NativeStackScreenProps<
  AccountStackParamList,
  name,
  "account"
>;

export type StringField = { [K in keyof FormData as FormData[K] extends string ? K : never]: FormData[K] };

export interface TextInputProps extends Omit<CustomTextInputProps, "theme"> {
  name: keyof StringField;
  control: Control<any>;
  rules?: RegisterOptions;
  countryField?: "country" | "secondaryCountry";
  errorClassName?: string;
}

export interface FormData {
  address: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  homeAddressFields?: Record<string, string>;

  secondaryAddress: string;
  secondaryAddress2: string;
  secondaryCity: string;
  secondaryState: string;
  secondaryPostalCode: string;
  secondaryCountry: string;
  secondaryAddressFields?: Record<string, string>;

  homePhone: string;
  mobilePhone: string;
  homePhoneCountryCode: CountryCode;
  mobilePhoneCountryCode: CountryCode;
}

export const defaultValues: FormData = {
  address: "",
  address2: "",
  city: "",
  state: "",
  postalCode: "",
  country: DEFAULT_COUNTRY_LABEL,

  secondaryAddress: "",
  secondaryAddress2: "",
  secondaryCity: "",
  secondaryState: "",
  secondaryPostalCode: "",
  secondaryCountry: DEFAULT_COUNTRY_LABEL,

  homePhone: "",
  mobilePhone: "",
  homePhoneCountryCode: "US",
  mobilePhoneCountryCode: "US",
};

export type Address = {
  id: string;
  address1: string;
  address2: string;
  addressType: "home" | "secondary";
  city: string;
  countryCode: string;
  isVerified: boolean;
  postalCode: string;
  state: string;
};

export type PersonPhone = {
  id: string;
  phoneNumber: string;
  phoneType: "home" | "mobile";
  phoneCountry: CountryCode;
  phoneFormatted: string;
};
